// extracted by mini-css-extract-plugin
export var infoRow = "_lu-2";
export var labelContainer = "_lu-0";
export var rightInfo = "_lu-1";